import { appConfig, headerConfig, refineHeader } from "../../config";

export const reportService = {
  saleReport,
  refundReport,
  transactionReport,
  payoutReport,
  getReport,
  getMonth,
  merchantPayoutDetail,
  markPayment,
  addPayouComment,
  getPayoutComment,
  getPayoutHistory,
};

function saleReport(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/sales-report`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function refundReport(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/refund-report`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function transactionReport(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/transaction-report`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function payoutReport(url, merchantID, postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
     body: ((merchantID) ? JSON.stringify({merchantID : (merchantID) ? merchantID : ""}) : JSON.stringify(postData))
  };
  // report/merchant-payout
  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getReport(postData, url) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getMonth(siteID) {
    refineHeader();
    const requestOptions = {
      method: "GET",
      headers: headerConfig.headerDatas
    };
  
    return fetch(`${appConfig.api.url}report/month-year/${siteID}`, requestOptions)
      .then(handleResponse)
      .then(data => {
        return data;
      });
}

function merchantPayoutDetail(postData) {
    refineHeader();
    const requestOptions = {
      method: "POST",
      headers: headerConfig.headerDatas,
      body: JSON.stringify(postData)
    };
  
    return fetch(`${appConfig.api.url}report/detail-merchant-payout`, requestOptions)
      .then(handleResponse)
      .then(data => {
        return data;
      });
}

function markPayment(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/mark-payment-merchant-payout`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function addPayouComment(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };
  return fetch(`${appConfig.api.url}report/add-comment-merchant-payout`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getPayoutComment(postData) {
    refineHeader();
    const requestOptions = {
      method: "GET",
      headers: headerConfig.headerDatas,
      body: JSON.stringify(postData)
    };
  
    return fetch(`${appConfig.api.url}report/comment-history-payout`, requestOptions)
      .then(handleResponse)
      .then(data => {
        return data;
    });
}

function getPayoutHistory(postData) {
    refineHeader();
    const requestOptions = {
      method: "POST",
      headers: headerConfig.headerDatas,
      body: JSON.stringify(postData)
    };
  
    return fetch(`${appConfig.api.url}report/pay-history-merchant-payout`, requestOptions)
      .then(handleResponse)
      .then(data => {
        return data;
      });
}
function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}


// WEBPACK FOOTER //
// ./src/app/services/API/reportService.js